import { API_URLS } from 'app-constants/api';
import { ApiRequest, ApiRequestWithParam } from 'types';
import secondaryHttpService from 'services/secondary-http.service';

import { TriggerPayload, KeyPayload } from 'store/admin/dump/slice';
import qs from 'qs';

export const listFolders: ApiRequest = () => secondaryHttpService.get(API_URLS.dumpfolders(), {});
export const downloadDump = async ({ key }: { key: string }): Promise<void> => {
  // const response = await secondaryHttpService.getDocumentInBlob(API_URLS.dumps(), { key });
  //
  // if (response.status < 200 || response.status >= 300) {
  //   throw new Error(`Download failed: ${response.status}`);
  // }
  //
  // const cd = response.headers['content-disposition'] || '';
  // const match = cd.match(/filename="?([^"]+)"?/i);
  // const fileName = match?.[1] || `${key}.zip`;
  //
  // const blob = new Blob([response?.data as BlobPart]);
  // const downloadUrl = URL.createObjectURL(blob);
  //
  // const a = document.createElement('a');
  // a.href = downloadUrl;
  // a.download = fileName;
  // document.body.appendChild(a);
  // a.click();
  // a.remove();
  //
  // URL.revokeObjectURL(downloadUrl);

  const baseUrl = `${API_URLS.secondary}${API_URLS.dumps()}`;
  const query = qs.stringify({ key }, { addQueryPrefix: true, encode: true });
  const url = `${baseUrl}${query}`;
  const fileName = `${key}.zip`;
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.target = '_self';
  a.rel = 'noopener';

  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const triggerExport = ({ period }: TriggerPayload) => {
  return secondaryHttpService.post(API_URLS.dumps(), null, { params: { period } });
};

export const deleteDump = ({ key }: KeyPayload) => {
  return secondaryHttpService.delete(API_URLS.dumps(), { params: { key } });
};
